/**
 * Logix Offline UI Manager
 * Handles offline/online status display and sync indicators.
 * Integrates with existing toast controller via CustomEvents.
 */

import { onSyncUpdate } from "./sync"
import { getSyncStatusSummary } from "./db"

let statusCheckInterval = null

export function initOfflineUI() {
  onSyncUpdate(handleSyncUpdate)

  statusCheckInterval = setInterval(updateSyncBadge, 30000)
  updateSyncBadge()
}

function handleSyncUpdate(status) {
  switch (status.status) {
    case "syncing":
      showSyncSpinner(true)
      break
    case "complete":
      showSyncSpinner(false)
      if (status.synced > 0) {
        showToast(`Synced ${status.synced} item(s)`, "success")
      }
      updateSyncBadge()
      break
    case "error":
      showSyncSpinner(false)
      showToast(`Sync failed: ${status.error}`, "error")
      break
  }
}

function showSyncSpinner(show) {
  const spinner = document.querySelector("[data-sync-status-target='spinner']")
  if (spinner) spinner.classList.toggle("hidden", !show)
}

async function updateSyncBadge() {
  try {
    const summary = await getSyncStatusSummary()
    const badge = document.querySelector("[data-sync-status-target='badge']")
    const count = document.querySelector("[data-sync-status-target='count']")
    const pendingCount = summary.pending + summary.failed

    if (badge && count) {
      if (pendingCount > 0) {
        count.textContent = pendingCount > 99 ? "99+" : pendingCount
        badge.classList.remove("hidden")
      } else {
        badge.classList.add("hidden")
      }
    }
  } catch {
    // IndexedDB not available
  }
}

function showToast(message, type = "info") {
  document.dispatchEvent(new CustomEvent("toast:show", { detail: { message, type } }))
}

export { showToast, updateSyncBadge }

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    if (statusCheckInterval) clearInterval(statusCheckInterval)
  })
}
